import { pluralizeRussian } from "../../lib/PluralizeRussian";

// Склонение существительного «прокси» по количеству: слово несклоняемое, поэтому
// все три формы совпадают, а согласование с числом идёт через общий выбор формы.
export function getProxiesWord(count: number): string {
  return pluralizeRussian(count, { one: "прокси", few: "прокси", many: "прокси" });
}
